import { fetchRequestWrapper } from './ui'
import { getGlobalFilesDownloadUrl } from '../selectors/config'
import { APPLICATION_JSON_HEADER_PROCESSING_MICROSERVICE } from '@layers-frontend/commons/constants'

export const REQUEST_BILABS_S3_URL = 'REQUEST_BILABS_S3_URL'

export const S3_PROTOCOL = 's3://'

/**
 * True when a BI Labs dashboard URL points at an S3 object (e.g. a stored HTML
 * report) rather than a directly-embeddable Power BI URL.
 * @param {string} url
 * @returns {boolean}
 */
export const isS3Url = url => typeof url === 'string' && url.startsWith(S3_PROTOCOL)

/**
 * Exchanges an `s3://bucket/key` URL for a short-lived presigned https URL by
 * hitting the processing microservice (`POST /s3/get_presigned_url`, the same
 * endpoint used to download global files). The presigned URL is what actually
 * gets embedded in the iframe so the stored HTML renders.
 *
 * Fails silently by design: any error (network, auth, missing object, expired
 * signature) resolves the thunk to `undefined` with no notification, so the
 * BI Labs page simply renders nothing for that dashboard instead of an error.
 *
 * The presigned URL is single-use and short-lived (~60s), so this must be
 * called fresh every time the dashboard is selected — never cached.
 *
 * @param {string} s3Url - full `s3://bucket/key` URL
 * @returns {Promise<string|undefined>} presigned https URL, or undefined on failure
 */
export const resolveBiLabsS3Url = s3Url => (dispatch, getState) => {
  const customRoute = getGlobalFilesDownloadUrl(getState())

  return dispatch(
    fetchRequestWrapper({
      requestType: REQUEST_BILABS_S3_URL,
      customRoute,
      overlay: false,
      onErroBehavior: 'ignore',
      onError: () => {},
      onSuccess: presignedUrl => ({ type: REQUEST_BILABS_S3_URL, presignedUrl }),
      fetchOptions: {
        method: 'POST',
        headers: APPLICATION_JSON_HEADER_PROCESSING_MICROSERVICE,
        body: JSON.stringify({ s3_url: s3Url })
      }
    })
  )
}
